import V2RewardHistoryTable from 'src/components/HistoryTables/V2RewardHistoryTable';
import PortfolioHistoryRewardsTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryRewardsTable/PortfolioHistoryRewardsTableControls';

export default function PortfolioHistoryRewardsTable() {
	return (
		<div>
			<PortfolioHistoryRewardsTableControls />
			<V2RewardHistoryTable />
		</div>
	);
}
